export const SET_TOKEN: string = "set token";
export const SET_REFRESH_TOKEN: string = "set refresh token";
export const CLEAR_STORE: string = "clear Store";
export const NOTIFICATION: string = "notification";
export const SET_THEME: string = "select theme";

export const INVALID_TOKEN: string = "Invalid access token";
export const EXPIRED_TOKEN: string = "The access token expired";

export const SET_USER: string = "set user";
export const SET_USER_LOADING: string = "user loading";
export const SET_USER_ERROR: string = "does user has error";

export const SET_TOP_TRACK_RECENT: string = "set top track recent";
export const SET_TOP_TRACK_RECENT_LOADING: string =
  "top track recent is loading";
  export const SET_TOP_TRACK_RECENT_ERROR: string = 'top track recent has error'

export const SET_TOP_TRACK_EVER: string = "set top track ever";
export const SET_TOP_TRACK_EVER_LOADING: string = "top track ever is loading";
export const SET_TOP_TRACK_EVER_ERROR: string = "top track ever has error";

export const SET_TOP_ARTIST_RECENT: string = "set top artist recent";
export const SET_TOP_ARTIST_RECENT_LOADING: string =
  "top artist recent is loading";
  export const SET_TOP_ARTIST_RECENT_ERROR: string = "top artist recent has error"

export const SET_TOP_ARTIST_EVER: string = "set top artist ever";
export const SET_TOP_ARTIST_EVER_LOADING: string = "top artist ever is loading";
export const SET_TOP_ARTIST_EVER_ERROR: string = "top artist ever has error";

export const SET_FOLLOWING_ARTIST: string = "set following artist";
export const SET_FOLLOWING_ARTIST_LOADING: string = "loading following artist";
export const SET_FOLLOWING_ARTIST_ERROR: string = "following artist has error";

export const SET_SAVED_ALBUM: string = "set saved album";
export const SET_SAVED_ALBUM_LOADING: string = "loading saved album";
export const SET_SAVED_ALBUM_ERROR: string = "saved album has error";

export const SET_RECOMMANDATION: string = "set recommandation";
export const SET_RECOMMANDATION_LOADING: string = "loading recommandation";
export const SET_RECOMMANDATION_MODAL: string = "manage recommandation modal";
export const SET_RECOMMANDATION_ERROR: string = "recommandation modal has error";
